import axios from "axios";
import { initialState } from "./initialState";
import { coRenterState } from "../helpers/coRenterState";
import populateContract from "../helpers/populateContract";
import { SET_LOADING } from "./basic";

const CREATE_CONTRACT_SUCCESS = "CREATE_CONTRACT_SUCCESS";
const CREATE_CONTRACT_FAILURE = "CREATE_CONTRACT_FAILURE";
const CREATE_CONTRACT_STARTED = "CREATE_CONTRACT_STARTED";

const FETCH_CONTRACT_SUCCESS = "FETCH_CONTRACT_SUCCESS";
const FETCH_CONTRACT_FAILURE = "FETCH_CONTRACT_FAILURE";
const FETCH_CONTRACT_STARTED = "FETCH_CONTRACT_STARTED";

const SUBMIT_CONTRACT_SUCCESS = "SUBMIT_CONTRACT_SUCCESS";
const SUBMIT_CONTRACT_FAILURE = "SUBMIT_CONTRACT_FAILURE";
const SUBMIT_CONTRACT_STARTED = "SUBMIT_CONTRACT_STARTED";

const ABANDON_CONTRACT_SUCCESS = "ABANDON_CONTRACT_SUCCESS";
const ABANDON_CONTRACT_FAILURE = "ABANDON_CONTRACT_FAILURE";
const ABANDON_CONTRACT_STARTED = "ABANDON_CONTRACT_STARTED";

const MARK_INCOMPLETE_SUCCESS = "MARK_INCOMPLETE_SUCCESS";
const MARK_INCOMPLETE_FAILURE = "MARK_INCOMPLETE_FAILURE";

const CLEAR_STORE = "CLEAR_STORE";

const GENERATE_PREVIEW_SUCCESS = "GENERATE_PREVIEW_SUCCESS";
const GENERATE_PREVIEW_FAILURE = "GENERATE_PREVIEW_FAILURE";

export const markIncomplete = (contractId) => {
  return (dispatch) => {
    axios
      .post("/modify-status/", {
        context: "mark_incomplete",
        entity_id: contractId,
      })
      .then(() => {
        dispatch(markIncompleteSuccess());
      })
      .catch((err) => {
        dispatch(markIncompleteFailure(err.response.data.ui_message));
      });
  };
};
const markIncompleteSuccess = () => ({ type: MARK_INCOMPLETE_SUCCESS });
const markIncompleteFailure = () => ({ type: MARK_INCOMPLETE_FAILURE });

export const createContract = () => {
  return (dispatch) => {
    axios
      .post("/add-contract-shell/")
      .then(({ data }) => {
        dispatch(
          createContractSuccess({
            id: data.id,
            use_default_pricebook: data.use_default_pricebook,
            dealer: data.dealer,
          })
        );
      })
      .catch((err) => {
        dispatch(createContractFailure(err.response.data.ui_message));
      });
  };
};

const createContractSuccess = (data) => ({
  type: CREATE_CONTRACT_SUCCESS,
  payload: {
    id: data.id,
    dealer: data.dealer,
    use_default_pricebook: data.use_default_pricebook,
  },
});

const createContractFailure = (err) => ({
  type: CREATE_CONTRACT_FAILURE,
  payload: err,
});

// CLEAR STORE
export function clearStore() {
  return { type: CLEAR_STORE };
}

// MAKES ACH PDF
export const submitContract = (postData, achData) => {
  return (dispatch) => {
    dispatch(submitContractStarted());

    axios
      .post("/contracts/ach-agreement-pdf/", achData)
      .then(({ data }) => {
        if (data.success) {
          return dispatch(generateContractPdf(postData));
        } else {
          dispatch({
            type: SUBMIT_CONTRACT_FAILURE,
            payload: data.contract_errors,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: SUBMIT_CONTRACT_FAILURE,
          payload: [err.response.data.ui_message],
        });
      });
  };
};

const generateContractPdf = (postData) => {
  return (dispatch) => {
    dispatch(submitContractStarted());

    axios
      .post("/contracts/submit-contract/", postData)
      .then(({ data }) => {
        if (data.success) {
          dispatch({ type: SUBMIT_CONTRACT_SUCCESS });
        } else {
          dispatch({
            type: SUBMIT_CONTRACT_FAILURE,
            payload: data.contract_errors,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: SUBMIT_CONTRACT_FAILURE,
          payload: [err.response.data.ui_message],
        });
      });
  };
};

export const generateContractPdfPreview = (contractId) => {
  return (dispatch) => {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });

    axios
      .post(`/contracts/${contractId}/generate-pdf-preview/`, {
        contract_id: contractId,
      })
      .then(({ data }) => {
        if (!data.success) {
          return dispatch({
            type: GENERATE_PREVIEW_FAILURE,
            payload: data.contract_errors,
          });
        }

        dispatch({
          type: GENERATE_PREVIEW_SUCCESS,
          payload: data,
        });
      })
      .then((err) => {
        if (err && err.type && err.type === "GENERATE_PREVIEW_FAILURE") return;

        dispatch(fetchContract(contractId, "preview"));
      })
      .catch((err) => {
        location.reload();
        // dispatch({
        //   type: GENERATE_PREVIEW_FAILURE,
        //   payload: err.response.data.ui_message,
        // });
      });
  };
};

const submitContractSuccess = () => ({
  type: SUBMIT_CONTRACT_SUCCESS,
});

const submitContractStarted = () => ({
  type: SUBMIT_CONTRACT_STARTED,
});

const submitContractFailure = (error) => ({
  type: SUBMIT_CONTRACT_FAILURE,
  payload: error,
});

export const abandonContract = (contractId, note) => {
  return (dispatch) => {
    dispatch(abandonContractStarted());

    axios
      .post(`/contracts/${contractId}/abandon-contract/`, {
        contract_id: contractId,
        cancel_reason: note,
      })
      .then(() => {
        window.location = "/dealer/contracts";
      })
      .catch((err) => {
        dispatch(abandonContractFailure(err.response.data.ui_message));
      });
  };
};

const abandonContractStarted = () => ({
  type: ABANDON_CONTRACT_STARTED,
});

const abandonContractFailure = (error) => ({
  type: ABANDON_CONTRACT_FAILURE,
  payload: error,
});

// FETCH CONTRACT
export const fetchContract = (id, step = "systems") => {
  return (dispatch) => {
    dispatch(fetchContractStarted());

    axios
      .get(`/contracts/${id}/`)
      .then(({ data }) => {
        const populatedContract = populateContract(data, step);
        dispatch(fetchContractSuccess(populatedContract));
      })
      .catch((err) => {
        dispatch(fetchContractFailure(err.response.data.ui_message));
      });
  };
};

const fetchContractSuccess = (contract) => ({
  type: FETCH_CONTRACT_SUCCESS,
  payload: contract,
});

const fetchContractStarted = () => ({
  type: FETCH_CONTRACT_STARTED,
});

const fetchContractFailure = (error) => ({
  type: FETCH_CONTRACT_FAILURE,
  payload: error,
});

function idReducer(state, action) {
  switch (action.type) {
    case CLEAR_STORE:
      return {
        ...initialState,
        coRenter: null,
        renter: {
          ...initialState.renter,
          references: [
            {
              id: null,
              email: "",
              first_name: "",
              last_name: "",
              phone: "",
              relationship: "",
            },
            {
              id: null,
              email: "",
              first_name: "",
              last_name: "",
              phone: "",
              relationship: "",
            },
          ],
        },
      };
    case CREATE_CONTRACT_SUCCESS:
      return {
        ...state,
        defaultPricebook: action.payload.use_default_pricebook,
        dealer: action.payload.dealer,
        id: action.payload.id,
        initLoading: false,
        loading: false,
      };
    case CREATE_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        initLoading: false,
      };
    case FETCH_CONTRACT_SUCCESS:
      return action.payload;
    // contract stuff
    case FETCH_CONTRACT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SUBMIT_CONTRACT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        showSuccess: true,
      };
    case SUBMIT_CONTRACT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case MARK_INCOMPLETE_SUCCESS:
      return {
        ...state,
        status: 0,
      };
    case MARK_INCOMPLETE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case ABANDON_CONTRACT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case ABANDON_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GENERATE_PREVIEW_SUCCESS:
      return {
        ...state,
        // loading: false,
      };
    case GENERATE_PREVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }

  return state;
}

export default idReducer;
